import { Container } from '@mui/material';
import GradientCircularProgress from './GradientCircularProgress';

type GradientCircularProgressContainerProps = {
  loadingMessage?: string;
};

const GradientCircularProgressContainer: React.FC<GradientCircularProgressContainerProps> = ({ loadingMessage }) => {
  return (
    <Container
      maxWidth="md"
      sx={{
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        height: '100vh',
      }}
    >
      <GradientCircularProgress loadingMessage={loadingMessage} />
    </Container>
  );
};

export default GradientCircularProgressContainer;
